import { pickThemeColor, pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';

export const StyledName = styled.p`
  margin: 0;
  color: ${pickThemeColor('BLACK_PRIMARY')};
  ${pickThemeFontStyles('16', '26', 'SEMI_BOLD')};
`;

export const StyledDescription = styled.p`
  margin: 0.25rem 0 0 0;
  ${pickThemeFontStyles('14', '20', 'NORMAL')};
  color: ${pickThemeColor('BLACK_PRIMARY')};
`;

export const StyledTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  align-items: center;
`;

export const StyledCardTitle = styled.span`
  color: ${pickThemeColor('DARK_PURPLE')};
  ${pickThemeFontStyles('20', '26', 'BOLD')};
`;
